import  './location-style.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import {LocationsProps} from "./LocationsProps";
import {LocationContent} from "./LocationContent";
import {Swiper, SwiperSlide} from "swiper/react";
import {LocationSliderConfig} from "./config/LocationSliderConfig";
export const Location = (props: LocationsProps) => {
    return(
        <section className={'Location'} id={'location'}>
            <div className={'container'}>
                <h1 className={'section__title'}>Наши локации</h1>
                <Swiper {...LocationSliderConfig} className={'swiper'}>
                    {props.locations.map((slide, index) => (
                        <SwiperSlide key={index} className={'swiper'}>
                            <LocationContent img={slide.img} alt={slide.alt}/>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                    <div className="swiper-pagination "></div>
                </Swiper>

            </div>
        </section>
    );
}